import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class ETLJobEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "ETLJob";
        this.primaryEnterpriseComponent = "ETLJob";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLJob";
        eom.enterpriseComponent = "ETLJob";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLJobExecution";
        eom.enterpriseComponent = "ETLJobExecution";
        eom.relationship = "ETLJobETLJobExecution";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLJobPreExecutionLog";
        eom.enterpriseComponent = "ETLJobPreExecutionLog";
        eom.relationship = "ETLJobExecutionETLJobPreExecutionLog";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLJobSystemExecutionLog";
        eom.enterpriseComponent = "ETLJobSystemExecutionLog";
        eom.relationship = "ETLJobExecutionETLJobSystemExecutionLog";
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "ETLJobExecutionLog";
        eom.enterpriseComponent = "ETLJobExecutionLog";
        eom.relationship = "ETLJobExecutionETLJobExecutionLog";
        this.enterpriseComponentMembers.set(eom.name, eom);


    }
}

export default ETLJobEnterpriseObjectMetadata;